export {} from '@lucidlink/web-fs/filespace';
export const DEFAULT_EVENTS_PAGE_LIMIT = 50;
export const MIN_EVENTS_PAGE_LIMIT = 1;
export const MAX_EVENTS_PAGE_LIMIT = 1000;
export var EventType;
(function (EventType) {
    EventType["FS_ENTRY_CREATED"] = "FS_ENTRY_CREATED";
    EventType["FS_ENTRY_DELETED"] = "FS_ENTRY_DELETED";
    EventType["FS_ENTRY_MODIFIED"] = "FS_ENTRY_MODIFIED";
    EventType["FS_ENTRY_MOVED"] = "FS_ENTRY_MOVED";
    EventType["FS_ENTRY_LINKED"] = "FS_ENTRY_LINKED";
    EventType["FS_ENTRY_UNLINKED"] = "FS_ENTRY_UNLINKED";
})(EventType || (EventType = {}));
export var EntryType;
(function (EntryType) {
    EntryType["FILE"] = "FILE";
    EntryType["DIR"] = "DIR";
    EntryType["SYMLINK"] = "SYMLINK";
})(EntryType || (EntryType = {}));
